import React, { Component } from "react";
import { connect } from "react-redux";
import { createUser, loginUser } from "../../reducers/user";
import { Form } from "../../components/forms/Form";
import Header from "../../components/header/HeaderLogin";
import { Link } from "react-router-dom";

import "../../App.css";

class Register extends Component {
  state = {
    inputs: inputsRaw,
    firstname: "ale",
    lastname: "loca",
    companyName: "asfa",
    email: "ale.locaw@yahoo.it",
    // password: "Demo123!",
    // repeatPassword: "Demo123!",
  };
  async componentDidMount() {
    if (this.props.user.authToken) {
      window.location.href = "/mystores";
    } else {
      // console.log("getting user");
      await this.props.loginUser();
    }
  }
  componentDidUpdate(oldProps, oldState) {
    if (
      oldProps.user.authToken !== this.props.user.authToken &&
      this.props.user.authToken
    ) {
      window.location.href = "/mystores";
    }
    if (oldProps.error !== this.props.error && this.props.error) {
      this.setState({
        inputs: this.state.inputs.map((input) => {
          if (input.target === "email") {
            return {
              ...input,

              error:
                this.props.error.response &&
                this.props.error.response.data.message,
            };
          }
          return input;
        }),
      });
    }
    if (
      oldState.repeatPassword !== this.state.repeatPassword ||
      oldState.password !== this.state.password
    ) {
      // console.log("changing");
      if (this.state.repeatPassword && this.state.repeatPassword !== "") {
        if (this.state.repeatPassword !== this.state.password) {
          this.setState({
            inputs: this.state.inputs.map((input) => {
              if (input.target === "repeatPassword") {
                return {
                  ...input,
                  error: "Le password non corrispondono",
                };
              }
              return input;
            }),
          });
        } else {
          this.setState({
            inputs: this.state.inputs.map((input) => {
              if (input.target === "repeatPassword") {
                return {
                  ...input,
                  error: null,
                };
              }
              return input;
            }),
          });
        }
      }
    }
  }

  _handleChangeInput = (target, value) => {
    this.setState({ [target]: value });
  };
  _handleSubmit = async () => {
    const { email, password, firstname, lastname, companyName } = this.state;
    // console.log("called");
    // console.log(email, password);
    await this.props.createUser({
      email,
      password,
      firstname,
      lastname,
      companyName,
    });
  };
  _isDisabled = () => {
    const inputStatus = this.state.inputs.map(
      (input) => !!this.state[input.target] && this.state[input.target] !== ""
    );
    const inputAreNotValid =
      typeof inputStatus.find((input) => !input) !== "undefined";
    const passwordMatch = this.state.password === this.state.repeatPassword;
    return inputAreNotValid || !passwordMatch;
  };

  render() {
    // console.log(this.state);
    // console.log(this.props);
    const { inputs } = this.state;
    return (
      <div className="login-container">
        <div className="login-title-section">
          <h1>Registrati</h1>
          <p>
            Hai già un account? <Link to="/login">Accedi</Link>
          </p>
        </div>
        <div className="login-form-buttons-container">
          <Form
            submitButton={{
              text: "REGISTRATI",
              disabled: this._isDisabled(),
              loading: this.props.loading,
            }}
            inputs={inputs}
            handleChangeInput={this._handleChangeInput}
            handleSubmit={this._handleSubmit}
            checkboxes={[
              {
                target: "acceptPrivacy",
                label: "Accetto modulo Privacy..",
              },
              {
                target: "acceptSubscription",
                label: "Tienimi in contatto",
              },
            ]}
          />
          {/* <LoginButtons /> */}
        </div>
      </div>
    );
  }
}

const inputsRaw = [
  { target: "email", placeholder: "Email", type: "email" },
  { target: "password", placeholder: "Password", type: "password" },
  {
    target: "repeatPassword",
    placeholder: "Ripeti Password",
    type: "password",
  },
  { target: "firstname", placeholder: "Nome", type: "text" },
  { target: "lastname", placeholder: "Cognome", type: "text" },
  { target: "companyName", placeholder: "Nome società", type: "text" },
];

const mapStateToProps = (state) => ({
  user: state.user.data,
  loading: state.user.loading,
  error: state.user.error,
});

export default connect(mapStateToProps, { createUser, loginUser })(Register);
